import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTooltipIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.8335 5.33333H9.16683V6.66667H7.8335V5.33333ZM7.8335 8H9.16683V12H7.8335V8ZM8.50016 2C4.82016 2 1.8335 4.98667 1.8335 8.66667C1.8335 12.3467 4.82016 15.3333 8.50016 15.3333C12.1802 15.3333 15.1668 12.3467 15.1668 8.66667C15.1668 4.98667 12.1802 2 8.50016 2ZM8.50016 14C5.56016 14 3.16683 11.6067 3.16683 8.66667C3.16683 5.72667 5.56016 3.33333 8.50016 3.33333C11.4402 3.33333 13.8335 5.72667 13.8335 8.66667C13.8335 11.6067 11.4402 14 8.50016 14Z",
		fill: "#3F5059"
	})
});
export default SvgTooltipIcon;
